module ProcessList {
    "use strict";
    import IFrendsResult = Shared.IFrendsResult;

    export class ProcessInstanceListService {
        static $inject = ["$http"];
        constructor(private $http: ng.IHttpService) {
        }

        public getProcessInstances(query: IProcessInstanceQuery, isSpinnerDisabled: boolean): ng.IPromise<IFrendsResult<IProcessInstanceData>> {
            return this.$http.get("ProcessInstance/GetProcessInstanceList", { params: query, disableSpinner: isSpinnerDisabled })
                .then(response => response.data);
        }

        public deleteAllProcessInstances(query: IProcessInstanceDeleteQuery): ng.IPromise<IFrendsResult<any>> {
            return this.$http.post("ProcessInstance/DeleteAllInState",  query )
                .then(response => response.data);
        }

        public acknowledgeAllErrors(query: IProcessInstanceAcknowledgeAllQuery): ng.IPromise<IFrendsResult<any>> {
            return this.$http.post("ProcessInstance/AcknowledgeAllErrors", query)
                .then(response => response.data);
        }
        public deleteSelectedInstances(query: {environmentName: string, processGuid: string, instanceIds: number[]}): ng.IPromise<IFrendsResult<any>> {
            return this.$http.post("ProcessInstance/Delete", query)
                .then(response => response.data);
        }
        public terminateSelectedInstances(query: string[]): ng.IPromise<IFrendsResult<any>> {
            return this.$http.post("ProcessInstance/TerminateProcessInstance", query)
                .then(response => response.data);
        }
        public acknowledgeSelectedInstances(query: {environmentName: string, processGuid: string, instanceIds: number[]}): ng.IPromise<IFrendsResult<any>> {
            return this.$http.post("ProcessInstance/AcknowledgeErrors", query)
                .then(response => response.data);
        }
        public setRetentionDays(query: IProcessSaveHistoryStorageDaysQuery): ng.IPromise<IFrendsResult<any>> {
            return this.$http.post("ProcessInstance/SaveHistoryStorageDays", query)
                .then(response => response.data);
        }
    }

    module.service("ProcessInstanceListService", ProcessInstanceListService);

    export interface IProcessInstanceQuery {
        processId: number;
        environmentName: string;
        agentGroupName: string;
        sortColumn?: string;
        sortDirection?: SortDirection;
        filterString?: string;
        stateFilter?: string;
        page?: number;
        timeLimit?: number;
        executionId?: string;
        itemsPerPage?: number;
        startTimeLimitUtc?: string;
        endTimeLimitUtc?: string;
    }

    export interface IProcessSaveHistoryStorageDaysQuery {
        storageDays: number;
        processGuid: string;
        environmentName: string;
    }

    export interface IProcessInstanceDeleteQuery {
        processGuid: string;
        environmentName: string;
        states: string[];
    }
    export interface IProcessInstanceAcknowledgeAllQuery {
        processGuid: string;
        environmentName: string;
        agentGroupName: string;
    }

    export class GroupedExecutionStates {
        public static get RUNNING_STATES(): ExecutionState[] { return [ExecutionState.Started]; }
        public static get SUCCESSFUL_STATES(): ExecutionState[] { return [ExecutionState.Finished]; }
        public static get ERROR_STATES(): ExecutionState[] { return [ExecutionState.Exception, ExecutionState.TerminatedByUser, ExecutionState.FinishedAsZombie]; }
        public static get ALL_FINISHED_STATES(): ExecutionState[] { return this.SUCCESSFUL_STATES.concat(this.ERROR_STATES); }
    }

    export enum ProcessInstanceFilter {
        ShowAll,
        ShowRunning,
        ShowFinished,
        ShowSuccessful,
        ShowFailed,
        ShowFailedNotAcknowledged
    }
   export enum ExecutionState {
        Started,
        FinishedAsZombie,
        TerminatedByUser,
        Exception,
        Finished
    }

   export enum SortDirection {
       Ascending,
       Descending
   }
}
